module.exports = __webpack_public_path__ + "static/media/check.0a2b22f2.gif";